(function () {
  'use strict';
  var review = document.documentElement.dataset.heftReview === 'true';
  if (review) {
    document.addEventListener('submit', function (event) {
      event.preventDefault(); event.stopImmediatePropagation();
    }, true);
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (link && /^\/(cart|checkout)(\/|\?|$)/.test(link.getAttribute('href'))) event.preventDefault();
    }, true);
  }
  var product = document.querySelector('[data-heft-product]');
  if (product) {
    var select = product.querySelector('[data-variant-select]');
    var status = product.querySelector('[data-variant-status]');
    var button = product.querySelector('[data-add-button]');
    var inquiry = product.querySelector('[data-product-inquiry]');
    function showImage(id) {
      if (!id || !product.querySelector('[data-image-id="' + id + '"]')) return;
      product.querySelectorAll('[data-image-id]').forEach(function (frame) { frame.hidden = frame.dataset.imageId !== id; });
      product.querySelectorAll('[data-image-target]').forEach(function (thumb) { thumb.setAttribute('aria-pressed', String(thumb.dataset.imageTarget === id)); });
    }
    function updateVariant(updateUrl) {
      var option = select.options[select.selectedIndex];
      var available = option.dataset.available === 'true';
      product.querySelector('[data-variant-price]').textContent = option.dataset.price;
      status.textContent = available ? status.dataset.availableText : status.dataset.soldOutText;
      button.disabled = !available;
      button.textContent = available ? button.dataset.addText : button.dataset.soldOutText;
      showImage(option.dataset.image);
      var destination = new URL(inquiry.href);
      destination.searchParams.set('product', inquiry.dataset.productTitle + ' | ' + option.textContent.trim());
      inquiry.href = destination.toString();
      if (updateUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url.toString());
      }
    }
    select.addEventListener('change', function () { updateVariant(true); });
    product.querySelectorAll('[data-image-target]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { showImage(thumb.dataset.imageTarget); });
    });
    updateVariant(false);
  }
  var size = document.getElementById('f-size');
  var params = new URLSearchParams(window.location.search);
  var intent = document.getElementById('f-intent');
  if (intent && ['product', 'delivery', 'appointment'].indexOf(params.get('intent')) !== -1) intent.value = params.get('intent');
  var finish = document.getElementById('f-finish');
  var finishIndex = ['natural', 'bleached'].indexOf(params.get('finish'));
  if (finish && finishIndex !== -1) finish.selectedIndex = finishIndex + 1;
  var optionalDetails = document.getElementById('heft-inquiry-options');
  if (optionalDetails && (params.has('size') || params.has('finish') || params.get('intent') === 'appointment')) optionalDetails.open = true;
  if (intent && optionalDetails) intent.addEventListener('change', function () { if (intent.value === 'appointment') optionalDetails.open = true; });
  if (size) {
    var keys = ['coffee-42','coffee-48','dining-60','dining-72','dining-79','dining-86','dining-94','dining-102','dining-110','dining-120','bench-42','bench-48','bench-55','bench-60','bench-72','bench-86','bench-94'];
    var index = keys.indexOf(params.get('size'));
    if (index !== -1 && size.options[index + 1]) size.selectedIndex = index + 1;
    var productInterest = params.get('product');
    var interest = productInterest;
    if (interest) interest = interest.replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 250);
    else if (index !== -1) interest = size.options[size.selectedIndex].textContent;
    if (interest) {
      var note = document.getElementById('heft-selection-note');
      note.textContent = interest; note.hidden = false;
      document.getElementById('heft-interest').value = interest;
    }
    if (!productInterest) size.addEventListener('change', function () {
      var text = size.selectedIndex > 0 ? size.options[size.selectedIndex].textContent : '';
      var note = document.getElementById('heft-selection-note');
      note.textContent = text; note.hidden = !text;
      document.getElementById('heft-interest').value = text;
    });
  }
})();
